import axios from "axios";

// Same-origin API path. The deployed Node server reverse-proxies this to NestJS.
export const nestApi = axios.create({
  baseURL: "/api",
});

nestApi.interceptors.request.use((config) => {
  const token = localStorage.getItem("humrahe_token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export default nestApi;
